import React from 'react';
import DocumentPaperLetter, { letter } from '../../DocumentPaperLetter';
import ContainerTables from './ContainerTables';
import GroupTables from './GroupTables';
import { agruparBidimensional, excludeFirst } from '../utils';

const IndividualCreditTables = ({
  groupTables,
  numbersPayments,
  paymentDays,
  requisition,
  fecha,
}) => {
  const groupTablesPartial = agruparBidimensional(excludeFirst(groupTables), 2);
  const numbersPaymentsPartial = agruparBidimensional(
    excludeFirst(numbersPayments),
    2
  );
  const paymentDaysPartial = agruparBidimensional(excludeFirst(paymentDays), 2);

  return (
    <>
      {groupTablesPartial?.map((groupTable2D, idx2D) => (
        <DocumentPaperLetter
          key={idx2D}
          style={{ fontSize: '7pt', paddingTop: 0, paddingBottom: 0 }}
        >
          {groupTable2D?.map((groupTable, idxGroup) => (
            <ContainerTables isIndividual key={idxGroup}>
              {groupTable.map((amounts, idxAmounts) => (
                <GroupTables
                  key={idxAmounts}
                  groupData={amounts}
                  numbersPayments={
                    numbersPaymentsPartial[idx2D][idxGroup][idxAmounts]
                  }
                  paymentDays={paymentDaysPartial[idx2D][idxGroup][idxAmounts]}
                  promotor={requisition.promotor}
                  fecha={fecha}
                  requisition={requisition}
                  letter={letter}
                />
              ))}
            </ContainerTables>
          ))}
        </DocumentPaperLetter>
      ))}
    </>
  );
};

export default IndividualCreditTables;
